export default __webpack_public_path__ + "static/media/wip.4288bb07.gif";